import { percentToDecimal } from '@calculations/decimal/percent';

import { onPartGrossMarginChange } from '../../calculations/recalculate';
import { validateGrossMargin } from '../../validations/gross-margin';
import { PriceFieldHandlerParams } from './types';

export function handlePartGrossMarginChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
  priceStrategyConfigs,
}: PriceFieldHandlerParams) {
  const grossMarginPercent = validateGrossMargin(state, {
    grossMargin: value,
    quoteLineUuid,
    quotePriceUuid,
    field: 'grossMargin',
  });

  if (!grossMarginPercent) {
    return;
  }

  const grossMargin = percentToDecimal(grossMarginPercent);

  onPartGrossMarginChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    grossMargin,
    priceStrategyConfigs,
  });
}

// @NOTE(mrs): Service charges do not have a gross margin
